import { type InboxEntry, InboxEntrySource } from '@this+that/models';

interface SuggestionViewer {
  userId?: string | null;
  defaultTaskGroupId?: string | null;
}

const MAX_INSERT_VERSION = 1;

const isFreshInsert = (entry: InboxEntry) =>
  (entry.version ?? 0) <= MAX_INSERT_VERSION;

const isOpen = (entry: InboxEntry) => !entry.resolvedAt && !entry.deletedAt;

const isAgentSuggestion = (entry: InboxEntry) =>
  entry.isSuggestion === true && entry.source === InboxEntrySource.AGENT;

export function isQualifyingSuggestionInsert(
  entry: InboxEntry,
  { userId, defaultTaskGroupId }: SuggestionViewer,
): boolean {
  if (!userId || !defaultTaskGroupId) return false;
  return (
    isAgentSuggestion(entry) &&
    entry.taskGroupId === defaultTaskGroupId &&
    entry.createdFor === userId &&
    isFreshInsert(entry) &&
    isOpen(entry)
  );
}
